module.exports = __webpack_public_path__ + "img/capa1.83075ca3.webp";